// extracted by mini-css-extract-plugin
export default {"main":"modal_main__SE6Cc"};